import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Award, Wallet, Headphones } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';

const icons = [Award, Wallet, Headphones];

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  return (
    <section data-testid="why-choose-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Why Us</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-6">
              The Right Team for Your Brand
            </h2>
            <p className="text-base text-[#4B5563] leading-relaxed mb-10">
              Thousands of businesses have trusted <strong className="text-[#0A0F1C]">Trademark Logo Design</strong> with their most valuable asset: their brand identity.
            </p>
            <Button
              data-testid="why-choose-cta"
              onClick={onOpenContactForm}
              className="bg-[#002FA7] hover:bg-[#002280] text-white font-medium px-8 py-5 rounded-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,47,167,0.3)]"
            >
              Start Your Registration <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>

          <div className="lg:col-span-7 space-y-5">
            {whyChooseUs.map((item, index) => {
              const Icon = icons[index] || Award;
              return (
                <div
                  key={item.id}
                  data-testid={`why-choose-card-${item.id}`}
                  className="group bg-white border border-[#E5E7EB] p-8 flex gap-6 items-start transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(10,15,28,0.06)] hover:border-[#002FA7]/30"
                >
                  <div className="w-12 h-12 border border-[#E5E7EB] flex items-center justify-center flex-shrink-0 group-hover:border-[#002FA7]/30 group-hover:bg-[#002FA7]/5 transition-all duration-500">
                    <Icon className="w-6 h-6 text-[#002FA7]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0A0F1C] mb-2">{item.title}</h3>
                    <p className="text-sm text-[#4B5563] leading-relaxed">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
